import { createGlobalStyle } from 'styled-components';

import reset from './reset';

import '@assets/fonts/icons/style.css';
import '@assets/fonts/fonts.css';

import { ViewModeQueries } from '@helpers/viewModeHelper';
import {
  FAVORITE_ONBOARD_KEY,
  PROMOTION_ONBOARD_KEY,
  PROMOTION_POST_KEY,
  PROMOTIONS_ONBOARD_KEY,
  SHOW_PATH,
  TRIGGER_PATH,
} from '@utils/onboarding';

const GlobalStyle = createGlobalStyle`
  ${reset}

  // additional reset
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
  }
  a {
    color: inherit;
    cursor: pointer;
  }
  button {
    cursor: pointer;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
  }
  input {
    font: inherit;
  }
  // additional reset
  
  // fix for user agent stylesheet
  button, textarea {
    font: inherit;
  }
  // fix for user agent stylesheet

  html, body {
    height: 100%;
  }
  html {
    ${({ theme }) => theme.fonts.primary.fontSize};
    scroll-behavior: smooth;
  }
  body {
    font-family: ${({ theme }) => theme.fonts.primary.fontFamily};
    color: ${({ theme }) => theme.colors.text.default};
    background-color: ${({ theme }) => theme.colors.background};
  }
  .no-scroll {
    overflow-y: hidden !important;
  }
  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  a.link_external {
    color: ${(props) => props.theme.colors.primary_lighter};
  }
  .nowrap {
    white-space: nowrap;
  }
  span .react-loading-skeleton {
    border-radius: ${(props) => props.theme.borderRadius.r8};
    line-height: inherit;
  }
  
  .primaryColor {
    color: ${({ theme }) => theme.colors.primary};
  }
  .infoColor {
    color: ${({ theme }) => theme.colors.info};
  }
  
  .html-renderer {
    p {
      font-size: ${(props) => props.theme.spaces.s12};
      line-height: ${(props) => props.theme.spaces.s16};

      ${ViewModeQueries.MD} {
        font-size: 14px;
        line-height: 18px;
      }
    }

    strong {
      font-weight: bold;
    }
    ul, ol {
      margin: 10px 0;
    }
    i, em {
      font-style: italic;
    }
    u {
      text-decoration: underline;
    }
    ul {
      list-style: disc inside none;
    }
    ol {
      list-style: decimal inside none;
    }
    ul li, ol li {
      margin: 2px 0;
    }
    h1 {
      font-weight: ${(props) => props.theme.fonts.h1.fontWeight};
      font-size: ${(props) => props.theme.fonts.h1.fontSize};
      line-height: ${(props) => props.theme.fonts.h1.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h1.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h1.lineHeight_md};
      }
    }
    h2 {
      font-weight: ${(props) => props.theme.fonts.h2.fontWeight};
      font-size: ${(props) => props.theme.fonts.h2.fontSize};
      line-height: ${(props) => props.theme.fonts.h2.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h2.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h2.lineHeight_md};
      } 
    }
    h3 {
      font-weight: ${(props) => props.theme.fonts.h3.fontWeight};
      font-size: ${(props) => props.theme.fonts.h3.fontSize};
      line-height: ${(props) => props.theme.fonts.h3.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h3.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h3.lineHeight_md};
      } 
    }
  }
  [class*="${TRIGGER_PATH}"][class$="${SHOW_PATH}"]  {
    pointer-events: none;
  }
  .${PROMOTIONS_ONBOARD_KEY}${TRIGGER_PATH}1${SHOW_PATH} {
    z-index: 1400;
    position: relative;
    background: white;
    padding: 10px;
    margin: -10px 0;
    border-radius: 4px;
  }
  .${PROMOTIONS_ONBOARD_KEY}${TRIGGER_PATH}2${SHOW_PATH} {
    z-index: 1400;
    position: relative;
    border-radius: 4px;
  }
  .${PROMOTIONS_ONBOARD_KEY}${TRIGGER_PATH}2${SHOW_PATH} img{
    filter: brightness(0.7);
  }
  .${PROMOTION_POST_KEY}${TRIGGER_PATH}1 {
    display: none;
  }
  .${PROMOTION_POST_KEY}${TRIGGER_PATH}1${SHOW_PATH} {
    position: relative;

    ${ViewModeQueries.XL} {
      display: block !important;
      position: absolute;
      background: #2A4E9F;
      height: 117%;
      width: 71%;
      z-index: 1402 !important;
      top: -11px;
      right: -20px;
      border-radius: 4px;
      border: 1px solid #FFF;
      
      ~.btn1, ~.btn2 {
        z-index: 1402;
      }
    }
  }
  .${PROMOTION_POST_KEY}${TRIGGER_PATH}1${SHOW_PATH} .btnComp {
    position: relative;
    top: 0;
  }
  .${PROMOTION_POST_KEY}${TRIGGER_PATH}1${SHOW_PATH}.btn1 {
    background: #2A4E9F;
    height: 100%;
    z-index: 1401;
    line-height: 57px;
    top: -0.7px;
    padding-right: 30px;
    border-radius: 4px 0 0 4px;
    border: 1px solid #FFF;
    padding-left: 5px;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
    border-left: 1px solid #FFF;
    border-right: 0;
  }

  .${PROMOTION_POST_KEY}${TRIGGER_PATH}1${SHOW_PATH}.btn2 {
    background: #2A4E9F;
    height: 100%;
    z-index: 1401;
    margin-left: -40px;
    padding-right: 5px;
    border-radius: 0  4px 4px 0;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
    border-right: 1px solid #FFF;
    border-left: 0;
  }
  .${PROMOTION_ONBOARD_KEY}${TRIGGER_PATH}1${SHOW_PATH} {
    z-index: 1400 !important;
    position: relative;
    border-radius: 4px;
    border: 1px solid #FFF;
    background: white;
    padding: 5px;
  }
  .${FAVORITE_ONBOARD_KEY}${TRIGGER_PATH}1${SHOW_PATH} {
    z-index: 1401 !important;
  }
  .${FAVORITE_ONBOARD_KEY}${TRIGGER_PATH}2${SHOW_PATH} {
    z-index: 1401 !important;
    position: relative;
    border-radius: 4px;
    
    img {
      filter: brightness(0.7);
    }
  }
`;

export default GlobalStyle;
